<template>
  <div>
    <topsearch title="Export Logları" />
    <div class="flex">
      <div class="w-72 border-r h-full">
        <SidebarVue />
      </div>
      <div class="w-full">
        <div class="overflow-scroll min-h-screen md:p-4">
          <!-- İstatistikler -->
          <div v-if="crmName" class="mb-4 border-b pb-2">
            <span class="text-xs text-gray-600">
              CRM: <strong>{{ crmName }}</strong> - Toplam: <strong>{{ totalRecords }}</strong> kayıt
            </span>
          </div>

          <!-- Tablo -->
          <div v-if="data.length > 0" class="heightoverflow text-sm">
            <table class="uk-table uk-table-hover uk-table-middle uk-table-divider w-full">
              <thead>
                <tr>
                  <th>#</th>
                  <th>CRM</th>
                  <th>Kullanıcı</th>
                  <th>Dosya Adı</th>
                  <th>Oluşturma Zamanı</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="item.id" v-for="item in data">
                  <td>{{ item.id }}</td>
                  <td>
                    <span class="uk-badge">{{ item.crm }}</span>
                  </td>
                  <td>
                    <span class="text-blue-600">{{ item.agent_name || 'Bilinmiyor' }}</span>
                    <span class="text-xs text-gray-500">(ID: {{ item.agent_id }})</span>
                  </td>
                  <td>
                    <div class="flex items-center gap-2">
                      <code class="text-xs">{{ item.file_name }}</code>
                      <button
                        @click="copyFileName(item.file_name)"
                        class="uk-button uk-button-default uk-button-small"
                        title="Dosya adını kopyala"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-4" fill="currentColor">
                          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                  <td>{{ formatDate(item.created_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Sayfalama -->
          <div v-if="totalPages > 1" class="mt-4 text-center">
            <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="uk-button uk-button-default uk-button-small"
            >
              « Önceki
            </button>

            <span class="mx-4 text-sm">
              {{ currentPage }} / {{ totalPages }} ({{ totalRecords }} kayıt)
            </span>

            <button
              @click="nextPage"
              :disabled="currentPage === totalPages"
              class="uk-button uk-button-default uk-button-small"
            >
              Sonraki »
            </button>
          </div>

          <!-- Boş durum -->
          <div v-else-if="data.length === 0 && !loading" class="text-center py-8">
            <p class="text-gray-500">Henüz export kaydı bulunmamaktadır.</p>
          </div>

          <!-- Yükleniyor durumu -->
          <div v-if="loading" class="text-center py-8">
            <div class="uk-spinner" uk-spinner="ratio: 1"></div>
            <p class="text-gray-500 mt-2">Yükleniyor...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import http from "../services/http";

export default {
  components: { SidebarVue },
  name: "ExportLogs",
  data() {
    return {
      data: [],
      crmName: "",
      currentPage: 1,
      totalRecords: 0,
      totalPages: 1,
      limit: 50,
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      http.getExportLogs(this.currentPage, this.limit).then((response) => {
        if (response.data.success) {
          this.data = response.data.data;
          this.crmName = response.data.crm_name;
          this.totalRecords = response.data.pagination.total;
          this.totalPages = response.data.pagination.totalPages;
          this.currentPage = response.data.pagination.page;
        }
        this.loading = false;
      }).catch((error) => {
        console.error("Export logları alınırken hata:", error);
        this.loading = false;
      });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getData();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getData();
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('tr-TR');
    },
    copyFileName(fileName) {
      // Clipboard API kullanarak dosya adını kopyala
      navigator.clipboard.writeText(fileName).then(() => {
        // UIKit notification göster
        if (window.UIkit && window.UIkit.notification) {
          window.UIkit.notification({
            message: 'Dosya adı kopyalandı!',
            status: 'success',
            pos: 'top-right',
            timeout: 2000
          });
        }
      }).catch((err) => {
        console.error('Kopyalama hatası:', err);
        if (window.UIkit && window.UIkit.notification) {
          window.UIkit.notification({
            message: 'Kopyalama başarısız!',
            status: 'danger',
            pos: 'top-right',
            timeout: 2000
          });
        }
      });
    }
  },
};
</script>

<style scoped>
.global-button {
  @apply px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition;
}
</style>
